var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogicalgroupgradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 14 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 6,
    x2: 14,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3aecfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4275ed"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.64,11.33h.64v.67H0v-1.33h.64v.67ZM13.36,11.33h-.64v.67h1.27v-1.33h-.64v.67ZM0,1.33h.64v-.67h.64v-.67H0v1.33ZM.64,2.67h-.64v1.33h.64v-1.33ZM.64,5.33h-.64v1.33h.64v-1.33ZM13.36,4h.64v-1.33h-.64v1.33ZM13.36,6.67h.64v-1.33h-.64v1.33ZM.64,8h-.64v1.33h.64v-1.33ZM13.36,9.33h.64v-1.33h-.64v1.33ZM2.55.67h1.27v-.67h-1.27v.67ZM6.36.67v-.67h-1.27v.67h1.27ZM7.64.67h1.27v-.67h-1.27v.67ZM11.45,0h-1.27v.67h1.27v-.67ZM2.55,12h1.27v-.67h-1.27v.67ZM5.09,12h1.27v-.67h-1.27v.67ZM7.64,12h1.27v-.67h-1.27v.67ZM10.18,12h1.27v-.67h-1.27v.67ZM12.73.67h.64v.67h.64V0h-1.27v.67ZM12.09,3.33v1.33c0,.18-.07.35-.19.47-.12.12-.28.2-.45.2H2.55c-.17,0-.33-.07-.45-.2-.12-.12-.19-.29-.19-.47v-1.33c0-.18.07-.35.19-.47.12-.12.28-.2.45-.2h8.91c.17,0,.33.07.45.2.12.12.19.29.19.47ZM11.46,4.67v-1.33H2.55v1.33h8.91ZM12.09,7.33v1.33c0,.18-.07.35-.19.47-.12.12-.28.2-.45.2H2.55c-.17,0-.33-.07-.45-.2-.12-.12-.19-.29-.19-.47v-1.33c0-.18.07-.35.19-.47.12-.12.28-.2.45-.2h8.91c.17,0,.33.07.45.2.12.12.19.29.19.47ZM11.46,8.67v-1.33H2.55v1.33h8.91Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogicalgroupgradient);
export default __webpack_public_path__ + "static/media/Logical group gradient.6d30b4526adf4da8b5eb1c5c8f2c1e40.svg";
export { ForwardRef as ReactComponent };